import {combineReducers} from 'redux';
import {persistReducer} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
// slices
import appReducer from './slices/app';
import userReducer from './slices/user';
import cardReducer from './slices/card';
import assetsReducer from './slices/assets';
import themeReducer from './slices/theme';
// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};
const appPersistConfig = {
  key: 'app',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};

const themePersistConfig = {
  key: 'theme',
  storage,
  keyPrefix: 'redux-',
  whitelist: [], // 'themeId', 'themeOptions', 'savedThemes'
};

const rootReducer = combineReducers({
  app: persistReducer(appPersistConfig, appReducer),
  user: userReducer,
  card: cardReducer,
  assets: assetsReducer,
  theme: persistReducer(themePersistConfig, themeReducer)
});

export {rootPersistConfig, rootReducer};
